import {
  createConfigProvisionings,
  updateConfigProvisionings,
  deleteConfigProvisionings
} from 'stores/slice/bogus/wired/configProvisionings';

import {
  getDefaultConfigProvisioningsByModel
} from 'stores/slice/bogus/wired/defaultConfigProvisionings';

import {
  setWiredQosData,
  updateWiredQosData,
} from 'stores/slice/bogus/wired/qos';

import {
  setWiredIpv4AclData,
  updateWiredIpv4AclData,
} from 'stores/slice/bogus/wired/ipv4Acl';

import {
  updateVoiceVlan
} from 'stores/slice/bogus/wired/voiceVlan';

const wiredConfig = {
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wiredConfig.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wiredConfig",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "wired",
  },
  "/orgs/:orgId/sites/:siteId/settings/wiredConfig.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/wiredConfig",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "wired",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wiredConfig.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wiredConfig",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params.updates }),
    action: null,
    mockSelector: "wired",
  },
  "/orgs/:orgId/sites/:siteId/settings/wiredConfig.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/wiredConfig",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params.updates }),
    action: null,
    mockSelector: "wired",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/ports.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/ports",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "wired",
  },
  "/orgs/:orgId/sites/:siteId/settings/ports.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/ports",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "wired",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/ports.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/ports",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params.updates }),
    action: null,
    mockSelector: "wired",
  },
  "/orgs/:orgId/sites/:siteId/settings/ports.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/ports",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params.updates }),
    action: null,
    mockSelector: "wired",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wiredQos.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wiredQos",
    restful: true,
    method: "read",
    buildParams: null,
    action: setWiredQosData,
    mockSelector: "wiredQos",
  },
  "/orgs/:orgId/sites/:siteId/settings/wiredQos.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/wiredQos",
    restful: true,
    method: "read",
    buildParams: null,
    action: setWiredQosData,
    mockSelector: "wiredQos",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wiredQos/:wiredQosId.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wiredQos/:wiredQosId",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: updateWiredQosData,
    mockSelector: "wiredQos",
  },
  "/orgs/:orgId/sites/:siteId/settings/wiredQos/:wiredQosId.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/wiredQos/:wiredQosId",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: updateWiredQosData,
    mockSelector: "wiredQos",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wiredIpAcls.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wiredIpAcls",
    restful: true,
    method: "read",
    buildParams: null,
    action: setWiredIpv4AclData,
    mockSelector: "wiredIpv4Acl",
  },
  "/orgs/:orgId/sites/:siteId/settings/wiredIpAcls.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/wiredIpAcls",
    restful: true,
    method: "read",
    buildParams: null,
    action: setWiredIpv4AclData,
    mockSelector: "wiredIpv4Acl",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wiredIpAcls.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wiredIpAcls",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: updateWiredIpv4AclData,
    mockSelector: "wiredIpv4Acl",
  },
  "/orgs/:orgId/sites/:siteId/settings/wiredIpAcls.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/wiredIpAcls",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: updateWiredIpv4AclData,
    mockSelector: "wiredIpv4Acl",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/tags/portTags.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/tags/portTags",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "portTags",
  },
  "/orgs/:orgId/sites/:siteId/settings/tags/portTags.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/tags/portTags",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "portTags",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/tags/portTags.create": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/tags/portTags",
    restful: true,
    method: "create",
    buildParams: null,
    action: null,
    mockSelector: null,
  },
  "/orgs/:orgId/sites/:siteId/settings/tags/portTags.create": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/tags/portTags",
    restful: true,
    method: "create",
    buildParams: null,
    action: null,
    mockSelector: null,
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wiredConfigProvisioning.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wiredConfigProvisioning",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "wiredConfigProvisionings",
  },
  "/orgs/:orgId/sites/:siteId/settings/wiredConfigProvisioning.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/wiredConfigProvisioning",
    restful: true,
    method: "read",
    buildParams: null,
    action: createConfigProvisionings,
    mockSelector: "wiredConfigProvisionings",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wiredConfigProvisioning.create": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wiredConfigProvisioning",
    restful: true,
    method: "create",
    buildParams: params => params,
    action: createConfigProvisionings,
    mockSelector: "wiredConfigProvisionings",
  },
  "/orgs/:orgId/sites/:siteId/settings/wiredConfigProvisioning.create": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/wiredConfigProvisioning",
    restful: true,
    method: "create",
    buildParams: params => params,
    action: createConfigProvisionings,
    mockSelector: "wiredConfigProvisionings",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wiredConfigProvisioning.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wiredConfigProvisioning",
    restful: true,
    method: "update",
    buildParams: params => params,
    action: updateConfigProvisionings,
    mockSelector: "wiredConfigProvisionings",
  },
  "/orgs/:orgId/sites/:siteId/settings/wiredConfigProvisioning.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/wiredConfigProvisioning",
    restful: true,
    method: "update",
    buildParams: params => params,
    action: updateConfigProvisionings,
    mockSelector: "wiredConfigProvisionings",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wiredConfigProvisioning.delete": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wiredConfigProvisioning",
    restful: true,
    method: "delete",
    buildParams: params => params,
    action: deleteConfigProvisionings,
    mockSelector: "wiredConfigProvisionings",
  },
  "/orgs/:orgId/sites/:siteId/settings/wiredConfigProvisioning.delete": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/wiredConfigProvisioning",
    restful: true,
    method: "delete",
    buildParams: params => params,
    action: deleteConfigProvisionings,
    mockSelector: "wiredConfigProvisionings",
  },
  "/system/wiredConfigProvisioning/defaultValues.read": {
    protocol: "ws",
    resource: "/system/wiredConfigProvisioning/defaultValues",
    restful: true,
    method: "read",
    buildParams: null,
    action: getDefaultConfigProvisioningsByModel,
    mockSelector: "defaultConfigProvisionings",
  },
  // Read all device models
  "/system/wiredConfigProvisioning/modelList.read": {
    protocol: "ws",
    resource: "/system/wiredConfigProvisioning/modelList",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "deviceModelList",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wiredVoiceVlan.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wiredVoiceVlan",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "wiredVoiceVlan",
  },
  "/orgs/:orgId/sites/:siteId/settings/wiredVoiceVlan.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/wiredVoiceVlan",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "wiredVoiceVlan",
  },
   "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wiredVoiceVlan/:id.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wiredVoiceVlan/:id",
    restful: true,
    method: "update",
    buildParams: params => ({ data: params }),
    action: updateVoiceVlan,
    mockSelector: "wiredVoiceVlan",
  },
  "/orgs/:orgId/sites/:siteId/settings/wiredVoiceVlan/:id.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/wiredVoiceVlan/:id",
    restful: true,
    method: "update",
    buildParams: params => ({ data: params }),
    action: updateVoiceVlan,
    mockSelector: "wiredVoiceVlan",
  },
};

export default wiredConfig;
